import PropTypes from "prop-types"
import OPTooltip from "components/material/tooltip"
import { InfoOutlined } from "@mui/icons-material"
import "./styles.scss"
import { TOOLTIP_ENTER_DELAY_MS } from "helpers/constants"

/**
 * A component that displays a metric value with an optional tooltip.
 */
export default function MetricWithTooltip({
  value,
  tooltip,
  showIcon = true,
}) {
  if (!tooltip) {
    return value
  }

  return (
    <OPTooltip
      enterDelay={TOOLTIP_ENTER_DELAY_MS}
      title={tooltip}
      placement="bottom-start"
      slotProps={{
        popper: {
          disablePortal: true,
        },
      }}
    >
      <span className="metric-with-tooltip">
        {showIcon && (
          <InfoOutlined
            fontSize="small"
            className="metric-tooltip-info"
          />
        )}
        <span className="metric-tooltip-value">{value}</span>
      </span>
    </OPTooltip>
  )
}

MetricWithTooltip.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]).isRequired,
  tooltip: PropTypes.string,
  showIcon: PropTypes.bool,
}
